module.exports = __webpack_public_path__ + "media/images/icons/comments-019e85579fef457008e1142e664ab0e8.svg";